import { addSheetBackLink, PARENT_SHEETS } from "../sheetNavigation.js";
import {
  BACK_ROW,
  BODY_FONT,
  HEADER_FONT_11,
  HEADER_ROW,
  VALUE_FILL,
  hideColumnsAfter,
  setCell,
} from "./detailSheetCommon.js";
import {
  COL_D,
  COL_E,
  COL_F,
  COL_G,
  COL_H,
  COL_I,
  COL_J,
  addSheetTitle,
  addTableSpacer,
  applyBorderPattern,
  outerRowPatterns,
  setupPrinciple2DetailSheet,
  writeDataRow,
} from "./principle2DetailHelpers.js";
import { excelWorksheetName, safeText, toYesNo } from "./principle6SheetHelpers.js";

export const SHEET_NAME = "Environmental impact";

const SHEET_TITLE =
  "Details of environmental impact assessments of projects undertaken by the entity based on applicable laws, in the current financial year:";

const WIDTHS = {
  A: 9.1796875,
  B: 9.1796875,
  C: 9.1796875,
  D: 7,
  E: 55.7265625,
  F: 25.453125,
  G: 21.26953125,
  H: 39.453125,
  I: 31.7265625,
  J: 17.453125,
  K: 9.1796875,
  L: 9.1796875,
};

const TEMPLATE_ROW = 10;
const SPACER_ROW = 11;
const DATA_START_ROW = 12;
const COL_END = COL_J;

const ALL_THIN = Array(7).fill("tttt");
const SPACER_BORDERS = outerRowPatterns(COL_D, COL_END);

function projectDetails(item) {
  const name = safeText(item?.nameOfProject, "");
  const brief = safeText(item?.projectBrief, "");
  if (name && brief && name !== "-" && brief !== "-") return `${name}\n${brief}`.trim();
  if (name && name !== "-") return name;
  if (brief && brief !== "-") return brief;
  return "";
}

export function buildEnvironmentalImpactSheet(workbook, sectionC) {
  const ws = workbook.addWorksheet(excelWorksheetName(SHEET_NAME), {
    views: [{ showGridLines: false }],
  });

  setupPrinciple2DetailSheet(ws, {
    widths: WIDTHS,
    colEnd: COL_END,
    ySplit: 11,
    topLeftCell: "D12",
    hiddenCols: ["A", "B"],
  });
  hideColumnsAfter(ws, 13);
  if (ws.views?.[0]) ws.views[0].xSplit = 0;

  addSheetBackLink(ws, PARENT_SHEETS.PRINCIPLE_6, {
    row: BACK_ROW,
    col: COL_END,
    mergeEnd: COL_END,
    align: "right",
    parentCell: "D8",
  });

  addSheetTitle(ws, COL_END, SHEET_TITLE, {
    borderPatterns: outerRowPatterns(COL_D, COL_END),
  });

  applyBorderPattern(ws, HEADER_ROW, COL_D, ALL_THIN);
  ws.getRow(HEADER_ROW).height = 29;
  [
    { col: COL_D, label: "Sr. No." },
    { col: COL_E, label: "Name and brief details of project" },
    { col: COL_F, label: "EIA Notification No." },
    { col: COL_G, label: "Date" },
    {
      col: COL_H,
      label: "Whether conducted by independent external agency (Yes / No)",
    },
    {
      col: COL_I,
      label: "Results communicated in public domain (Yes / No)",
    },
    { col: COL_J, label: "Relevant Web link" },
  ].forEach(({ col, label }) => {
    setCell(ws, HEADER_ROW, col, label, {
      font: HEADER_FONT_11,
      bold: false,
      bordered: false,
      align: "center",
    });
  });

  applyBorderPattern(ws, TEMPLATE_ROW, COL_D, ALL_THIN);
  for (let col = COL_D; col <= COL_END; col += 1) {
    setCell(ws, TEMPLATE_ROW, col, "", { bordered: false, font: BODY_FONT });
  }
  ws.getRow(TEMPLATE_ROW).height = 11.25;
  ws.getRow(TEMPLATE_ROW).hidden = true;

  addTableSpacer(ws, COL_D, COL_END, { row: SPACER_ROW, height: 30, patterns: SPACER_BORDERS });

  const rows = sectionC?.principle6?.essentialIndicators?.projectUndertakenByentity || [];
  const dataRows = Array.isArray(rows) && rows.length ? rows : [{}];

  dataRows.forEach((item, idx) => {
    const row = DATA_START_ROW + idx;
    writeDataRow(
      ws,
      row,
      COL_D,
      COL_END,
      [
        { col: COL_D, value: idx + 1, align: "center", fill: null, font: BODY_FONT },
        { col: COL_E, value: projectDetails(item), align: "left", fill: VALUE_FILL, vertical: "top" },
        {
          col: COL_F,
          value: safeText(item?.EIANotification, ""),
          align: "center",
          fill: VALUE_FILL,
        },
        {
          col: COL_G,
          value: safeText(item?.dateOfNotification, ""),
          align: "center",
          fill: VALUE_FILL,
        },
        {
          col: COL_H,
          value: toYesNo(item?.extenalAgecy),
          align: "center",
          fill: VALUE_FILL,
        },
        {
          col: COL_I,
          value: toYesNo(item?.publicDomain),
          align: "center",
          fill: VALUE_FILL,
        },
        {
          col: COL_J,
          value: safeText(item?.link, ""),
          align: "left",
          fill: VALUE_FILL,
        },
      ],
      { patterns: ALL_THIN }
    );
  });

  return ws;
}
